import React from 'react';
import { ShieldCheckIcon, CodeBracketIcon, ServerIcon, AcademicCapIcon, CloudIcon, CogIcon } from '@heroicons/react/24/outline';

const Skills = ({ skills }) => {
  // Icons for each category
  const categoryIcons = {
    "Cloud Computing": <CloudIcon className="h-8 w-8 text-primary-500" />,
    "DevOps": <CogIcon className="h-8 w-8 text-primary-500" />,
    "Security": <ShieldCheckIcon className="h-8 w-8 text-primary-500" />,
    "Programming": <CodeBracketIcon className="h-8 w-8 text-primary-500" />,
    "Tools & Technologies": <ServerIcon className="h-8 w-8 text-primary-500" />,
    "Web Development": <CodeBracketIcon className="h-8 w-8 text-primary-500" />,
    "Certifications": <AcademicCapIcon className="h-8 w-8 text-primary-500" />
  };

  return (
    <div className="section bg-dark-900">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary-300">
            Capabilities
          </p>
          <h2 className="text-3xl font-bold text-white sm:text-4xl">Core Technical Skills</h2>
          <p className="mt-4 text-lg leading-8 text-gray-400">
            Practical experience across cloud platforms, delivery automation, security controls, and application tooling.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
          {skills && skills.map((skillCategory, index) => (
            <div key={index} className="rounded-lg border border-dark-700 bg-dark-800 p-6 transition-colors hover:border-primary-700">
              <div className="flex items-center border-b border-dark-700 pb-4">
                {categoryIcons[skillCategory.category] || <ShieldCheckIcon className="h-8 w-8 text-primary-500" />}
                <h3 className="text-xl font-bold text-white ml-3">{skillCategory.category}</h3>
              </div>
              
              <div className="flex flex-wrap gap-2.5 mt-5">
                {skillCategory.items.map((skill, skillIndex) => (
                  <span key={skillIndex} className="rounded-md border border-dark-600 bg-dark-900 px-3 py-1.5 text-sm font-medium text-gray-200">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
